import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Choose token: admin token for admin URLs; otherwise buyer token or fall back to admin
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const method = (config.method || "").toLowerCase();
  const adminOnly =
    url.includes("/admin/") ||
    url.includes("/auth/admin/") ||
    url.includes("/imports/") ||
    url.startsWith("/vendors") || url.includes("/vendors/") ||
    (["post", "patch", "delete", "put"].includes(method) &&
      (url.includes("/products") || url.includes("/tile-layers")));

  const buyerToken = localStorage.getItem("dtile_buyer_token");
  const adminToken = localStorage.getItem("dtile_admin_token");
  const token = adminOnly ? adminToken : (buyerToken || adminToken);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalize FastAPI 422 error detail (which is an array of {loc,msg,type} objects) to a string.
    // Without this, `toast.error(err.response.data.detail)` renders an array of objects
    // and crashes React with "Objects are not valid as a React child".
    const d = err.response?.data?.detail;
    if (Array.isArray(d)) {
      err.response.data.detail = d
        .map((x) => {
          if (!x || typeof x === "string") return String(x || "");
          const loc = Array.isArray(x.loc) ? x.loc.filter((s) => s !== "body").join(".") : "";
          return loc ? `${loc}: ${x.msg || x.type || "invalid"}` : (x.msg || x.type || JSON.stringify(x));
        })
        .filter(Boolean)
        .join(" · ");
    } else if (d && typeof d === "object") {
      err.response.data.detail = d.msg || d.message || JSON.stringify(d);
    }
    if (err.response?.status === 401) {
      const url = err.config?.url || "";
      if (url.includes("/admin/") || url.includes("/auth/admin/")) {
        localStorage.removeItem("dtile_admin_token");
        if (window.location.pathname.startsWith("/admin")) window.location.href = "/admin";
      } else if (!url.includes("/auth/buyer/login") && !url.includes("/auth/buyer/signup")) {
        localStorage.removeItem("dtile_buyer_token");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
